<ng-container content>
    <div style="padding: 0 16px 0 32px">
        <aumico-organization-general-information-page
            [countryOptions]="countries"
            [proceedButtonEvent$]="proceedButtonEvent$"
            [save$]="saveOrganization.asObservable()"
            (initialOrganizationProfile)="onInitialOrganizationProfile($event)"
            (organizationProfileChanges)="onOrganizationProfileChange($event)"
        ></aumico-organization-general-information-page>
    </div>
</ng-container>
<ng-template #footerTemplate>
    <aum-action-bar-pure
        nextButtonText="{{'aumico_button_save' | i18next}}"
        [nextButtonAction]="saveButtonClicked"
    ></aum-action-bar-pure>
</ng-template>
